import { RootState } from '..';

export const selectRobotsData = (state: RootState) => state.robots.robots;
export const selectSelectedRobotId = (state: RootState) => state.robots.robots.selectedId;
export const selectIsRobotDeploymentActive = (state: RootState) =>
  state.robots.robots.currentRobot?.deploymentDates.end == null;
export const selectHasCompletedFullDataSync = (state: RootState) =>
  state.robots.robots.currentRobotData.localDataState?.hasCompletedFullDataSync;
export const selectMissionsHistoryData = (state: RootState) => state.robots.missions;
export const selectSelectedMissionData = (state: RootState) => state.robots.missions.currentMission;

export const selectLocalRobotDataState = (state: RootState) =>
  state.robots.robots.currentRobotData.localDataState;

export const selectTags = (state: RootState) => state.robots.tags.data;
export const selectTagsRest = (state: RootState) => state.robots.tags.rest;

export const selectErrors = (state: RootState) => state.robots.errors.data;
export const selectErrorsRest = (state: RootState) => state.robots.errors.rest;

export const selectTorizonData = (state: RootState) => state.robots.torizon;
